import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CanActivate, GuardResult, MaybeAsync } from '@angular/router';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { CmsService, RoutingService } from '@spartacus/core';
import { catchError, filter, map, of, switchMap } from 'rxjs';
import { PaymentService } from 'src/app/service/payment/payment.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentVerificationGuard implements CanActivate {
  constructor(
    private paymentService: PaymentService,
    private cartService: ActiveCartFacade,
    private routingService: RoutingService,
    protected cms: CmsService
  ) {}

  canActivate(): MaybeAsync<GuardResult> {
    return this.cartService.takeActiveCartId().pipe(
      filter(Boolean), // Ensure activeCartId is valid
      switchMap((activeCartId) =>
        this.routingService.getNextPageContext().pipe(
          filter(Boolean), // Ensure nextPage is valid
          switchMap(
            (nextPage) =>
              nextPage.id === '/order-confirmation' ? of(true) : this.paymentService.verifyPayment(activeCartId) // verify payment of order confirmation page happens in OrderConfirmationComponent
          ),
          map(() => true),
          catchError((errResponse) =>
            // redirect to Payment Confirmation page happens in ShimanoAuthErrorInterceptor
            this.isCartModificationPaymentError(errResponse) ? of(false) : of(true)
          )
        )
      )
    );
  }

  isCartModificationPaymentError(resp: HttpErrorResponse): boolean {
    return resp.error.errors.some((err: any) => err.type === 'ShimanoCartModificationPaymentError');
  }
}
